





















import {
  Component, Vue, Prop
} from 'vue-property-decorator';
import { Models } from '@mtap-smartcity/api';
import { isGateway, isLamp } from '@/utils/type_check';
import ConsumptionCard from './ConsumptionCard.vue';
import ConsumptionCardGatewayMtap7V1 from './ConsumptionCardGatewayMtap7V1.vue';
import { ControllerTypes } from '../AnalyticsCard.vue';

@Component({
  components: {
    ConsumptionCard,
    ConsumptionCardGatewayMtap7V1
  }
})
/**
 * @group Analytics Card
 * Analytics tab with lamp energy consumption chart
 */
export default class AnalyticsCardAnalyticsTab extends Vue {
  // Selected lamp data object
  @Prop({ type: Object, validator: (d) => isLamp(d) || isGateway(d) }) readonly selectedDevice!: Models.Devices.Lamp | Models.Devices.Gateway | null;

  @Prop({ type: Object }) readonly selectedElement!: Models.Circuits.Model | Models.Groups.Model | null;

  @Prop({
    type: Object,
    // temporary 'any | null' type to be transformed into 'Models.Telemetries.Telemetry | null'
  }) readonly telemetryData!: any | null;

  @Prop({
    type: String,
  }) readonly telemetryControllerType!: ControllerTypes | undefined;

  get isGatewayMtap7V1() {
    return this.selectedDevice && this.selectedDevice.controller_type === 'GATEWAY_MTAP_7_V1';
  }
}
